import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import Amplify from '@aws-amplify/core';

if (environment.production) {
  enableProdMode();
}

// we setup our initial AWS config here...
 // configure the AWS library here.
 let awsConfigData = {
   Auth: {

  // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
  // identityPoolId: dacConfig.awsCognitoConfig.userPool.userIdentityPoolId, // 'us-east-1:0c4629df-3bcc-49b5-be6e-5861d5283b56',
  
  // REQUIRED - Amazon Cognito Region
  region: environment.awsCognitoConfig.awsCognitoRegion, // 'us-east-1',

  // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
  // Required only if it's different from Amazon Cognito Region
  // identityPoolRegion: 'XX-XXXX-X',

  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: environment.awsCognitoConfig.userPool.userPoolsId, // 'us-east-1_s9iDqPquj',

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolWebClientId: environment.awsCognitoConfig.userPool.webClientId, //'1271f4r7a3f24kk53j6emll9nb',

  // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
  mandatorySignIn: false,

  // OPTIONAL - Configuration for cookie storage
  // cookieStorage: {
  // // REQUIRED - Cookie domain (only required if cookieStorage is provided)
  //     domain: '.yourdomain.com',
  // // OPTIONAL - Cookie path
  //     path: '/',
  // // OPTIONAL - Cookie expiration in days
  //     expires: 365,
  // // OPTIONAL - Cookie secure flag
  //     secure: true
  // },

  // OPTIONAL - customized storage object
  // storage: new MyStorage(),
  
  // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
  // authenticationFlowType: 'USER_PASSWORD_AUTH'
  authenticationFlowType: 'USER_SRP_AUTH'
}
 }
 Amplify.configure(awsConfigData);

platformBrowserDynamic([
  {provide:'AuthToken', useValue: environment.token}
  ,{provide: 'StripePublicKey', useValue: environment.stripePublicKey}
  ,{provide: 'StripeChargeName', useValue: environment.stripeChargeName}
  ,{provide:'EnabledFeatures', useValue: environment.features}
  ,{provide: 'Environment', useValue: environment}]).bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts